export default __webpack_public_path__ + "static/media/Moki Kits@3x.dcb7c680.png";